import {
    IGetAllAssignmentPeriodsProps,
    IGetAssignmentPeriodsProps,
    IGetNextOnlineLessonsProps,
} from '@fsd-shared/models/assignment';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { AssignmentProvider } from './assignment-api';

export const getAssignmentPeriodsAction = createAsyncThunk(
    'assignment/getAssignmentPeriodsAction',
    async (props: IGetAssignmentPeriodsProps) => {
        return await AssignmentProvider.getAssignmentPeriods(props);
    },
);

export const getAllAssignmentPeriodsAction = createAsyncThunk(
    'assignment/getAllAssignmentPeriodsAction',
    async (props: IGetAllAssignmentPeriodsProps) => {
        const { courseGroup, assignments } = props;

        return await Promise.all(
            assignments.map(async (item) => {
                return {
                    assignment: item,
                    periodsData: await AssignmentProvider.getAssignmentPeriods({ courseGroup, assignment: item }),
                };
            }),
        );
    },
);
export const getNextOnlineLessonsAction = createAsyncThunk(
    'assignment/getNextOnlineLessonsAction',
    async (props: IGetNextOnlineLessonsProps) => {
        return await AssignmentProvider.getNextOnlineLessons(props);
    },
);
